import { Component, h } from 'preact'
import Checkbox from '../../control-components/ui-components/Checkbox'
import InputGroup from '../../control-components/ui-components/InputGroup'

interface Props {
  title: string
  showTotalTopics: boolean
  showTotalComments: boolean
  showTotalUsers: boolean
  onChange: (state: {
    title: string,
    showTotalTopics: boolean,
    showTotalComments: boolean,
    showTotalUsers: boolean
  }) => void
}

interface State {
  title: string
  showTotalTopics: boolean
  showTotalComments: boolean
  showTotalUsers: boolean
}

export default class CommunityStatisticsConfigurator extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      title: props.title,
      showTotalTopics: props.showTotalTopics || true,
      showTotalComments: props.showTotalComments || true,
      showTotalUsers: props.showTotalUsers || true,
    }

    this.notifyChanges = this.notifyChanges.bind(this)
    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({
      title: newTitle
    }, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange(this.state)
  }

  render (_: Props, {title, showTotalTopics, showTotalComments, showTotalUsers} : State) {
    return (
      <div class='community-statistics-widget__configurator'>
        <InputGroup
          title='Title'
          type='text'
          qaClasses='qa-widget__title'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />
        <Checkbox
          label='Show total topics'
          onUpdate={(showTotalTopics: boolean) => this.setState({showTotalTopics}, this.notifyChanges)}
          qaClasses='qa-total-topics'
          checked={showTotalTopics}
        />
        <Checkbox
          label='Show total comments'
          onUpdate={(showTotalComments: boolean) => this.setState({showTotalComments}, this.notifyChanges)}
          qaClasses='qa-total-comments'
          checked={showTotalComments}
        />
        <Checkbox
          label='Show total users'
          onUpdate={(showTotalUsers: boolean) => this.setState({showTotalUsers}, this.notifyChanges)}
          qaClasses='qa-total-users'
          checked={showTotalUsers}
        />
      </div>
    )
  }
}
